import React from "react";
import { getUuid } from "../units";

export interface InputRadioProps {
    name?:string,
    value:string,
    label?:string,
}

 const InputRadio:React.FC<InputRadioProps> = ({ value,name = 'radio',label }) => {

    const id = 'id' + getUuid().slice(0,5);

    return <div className="input-radio">
        <label htmlFor={id}/>
            <input type="radio" value={ value } name={ name } id={ id }/>
            <span className='icon'/>
            <span>{ label }</span>
    </div>
}

export const InputRadioGroup:React.FC<any> = (props) => {
    return <div className='input-radio-group'>
        {
            props.children
        }
    </div>
}

export default InputRadio;
